var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8995 6.65987L19.1195 7.12986L18.6295 7.42985L17.6996 7.97983L3.75995 16.3396L3.66995 16.3896L3.13997 16.7096L2.52999 17.0796C2.17 16.1896 2 15.0696 2 13.6997V8.29983C2 3.79995 3.79995 2 8.29983 2H13.6997C17.6096 2 19.4795 3.35996 19.8995 6.65987Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 8.20117V13.701C20 18.2009 18.2001 20.0008 13.7002 20.0008H8.30033C5.8604 20.0008 4.21044 19.4709 3.23047 18.2609L3.53046 18.0809L4.14044 17.7109L4.67043 17.3909L4.76043 17.3409L18.7001 8.98115L19.63 8.43117L20 8.20117Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightJobIcon);
export default __webpack_public_path__ + "static/media/nightJobIcon.7bb672670607c777d611ef6645422d50.svg";
export { ForwardRef as ReactComponent };